import { gql } from "@apollo/client";

export const GUEST_GET_PHONE = gql`
  query guestGetPhone($id: Int!) {
    Web {
      getPhone(id: $id)
    }
  }
`;

export const GET_PHONE = gql`
  query guestPhone($id: Int!) {
    Listing {
      getPhone(id: $id)
    }
  }
`;

export const GET_PHONES = gql`
  query getPhones($user_id: Int!) {
    User {
      getPhones(user_id: $user_id)
    }
  }
`;

export const GUEST_GET_PHONES = gql`
  query guestGetPhones($user_id: Int!) {
    User {
      getPhones(user_id: $user_id)
    }
  }
`;

export const GET_PHONE_AS_STRING = gql`
  query getPhoneAsString($id: Int!, $whatsapp: Boolean) {
    Listing {
      getPhoneAsString(id: $id, whatsapp: $whatsapp)
    }
  }
`;

export const GET_WHATSAPP_LINK = gql`
  mutation initWhatsapp($id: Int!) {
    Listing {
      initWhatsappUserBrokerCommunication(listing_id: $id, language: ar) {
        message
        link
        redirect_url
      }
    }
  }
`;
